import "./footer.css";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLocalizedPath, { isHomePath } from "../use-localized-path";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const localize = useLocalizedPath();

  const goToContact = () => {
    navigate(localize("/contact-us/#contactForm"));
  };

  const serviceClick = (e) => {
    e.preventDefault();
    if (!isHomePath(location.pathname)) {
      navigate(localize("/#ourServices"));
      setTimeout(() => {
        const section = document.getElementById("ourServices");
        if (section) section.scrollIntoView({ behavior: "smooth" });
      }, 500);
    } else {
      const section = document.getElementById("ourServices");
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <div className="footer-top-section">
        <div className="footer-solutions-container">
          <p>{t("We are Here")}</p>
          <h2>{t("Let's Talk Solutions!")}</h2>
          <p className="footer-solutions-desc">
            {t("Unlock the power of seamless organization with our comprehensive range of services, including expert ERP solutions, cutting-edge analytics support, and fortified cyber security. Connect with us today to shape your project together.")}
          </p>
          <button className="contact-btn" type="button" onClick={goToContact}>
            {t("Contact Us")}
          </button>
        </div>
      </div>

      <footer className="footer">
        {/* 1️⃣ Company Info */}
        <div className="footer-section-width">
          <div className="footer-column footer-brand-row">
            <div className="sigvion-footer-logo-container">
              <img
                src="/assets/images/sigvion-logo.webp"
                alt="sigvion-logo"
              ></img>
              <h4>Sigvion</h4>
            </div>
            <p>
              {t("Elevating Your Organizations Potential Through Innovative Solutions and Unparalleled Support.")}
            </p>
          </div>

          <div className="footer-section">
            {/* 2️⃣ Sitemap */}
            <div className="footer-column">
              <h4>{t("Sitemap")}</h4>
              <div className="footer-nav-links">
                <NavLink to={localize("/")}>
                  <span className="footer-nav-item">{t("Home")}</span>
                </NavLink>
                <NavLink to={localize("/#ourServices")} onClick={serviceClick}>
                  <span className="footer-nav-item">{t("Services")}</span>
                </NavLink>
                <NavLink to={localize("/about-us")}>
                  <span className="footer-nav-item">{t("About Us")}</span>
                </NavLink>
                <NavLink to={localize("/contact-us")}>
                  <span className="footer-nav-item">{t("Contact Us")}</span>
                </NavLink>
              </div>
            </div>

            {/* 3️⃣ Address */}
            <div className="footer-column">
              <h4>{t("USA Address")}</h4>
              <p>
                805 Marbella Vista way,
                <br />
                Leander, TX, 78641 <br />
                USA
              </p>
              <div className="contact-details">
                <h3>{t("Contact")}</h3>
                <span>
                  {t("Email")}: <a href="mailto:contact@Sigvion.com">contact@sigvion.com</a>
                </span>
                <br />
                <span>
                  {t("Phone")}: <a href="tel:+16504279816">+1 6504279816</a>
                </span>
              </div>
            </div>

            <div className="footer-column">
              <h4>{t("Germany Address")}</h4>
              <p>
                Hinterer Rosengarten 24,<br/>
                97253 Gaukönigshofen<br/>
                Germany
              </p>
              <div className="contact-details">
                <h3>{t("Contact")}</h3>
                <span>
                 {t("Email")}: <a href="mailto:contact@Sigvion.com">contact@sigvion.com</a>
                </span>
                <br />
                <span>
                  {t("Phone")}: <a href="tel:+4915129035145">+49 15129035145</a>
                </span>
              </div>
            </div>

            
            <div className="footer-column">
              <h4>{t("India Address")}</h4>
              <p>
                #308, DSL ABACUS IT Park,<br/>
                Industrial Development Area,<br/>
                Uppal, Secunderabad, Telangana, India
              </p>
              <div className="contact-details">
                <h3>{t("Contact")}</h3>
                <span>
                 {t("Email")}: <a href="mailto:contact@Sigvion.com">contact@sigvion.com</a>
                </span>
                <br />
                <span>
                  {t("Phone")}: <a href="tel:+919381362469">+91 9381362469</a>
                </span>
              </div>
            </div>
            
          </div>
          <p className="copy-right-section">
            {t("copyright", { year: new Date().getFullYear() })}
          </p>
        </div>
      </footer>
    </div>
  );
}
